export const IconFormKeyValuePairTypes = {
  link: 'Link',
  property: undefined,
};
